import { saveLabel } from "./persistence.js";
/* global Flash */

const normalizeBlankValue = (value) => {
  return value.trim() === "" ? "" : value;
};

const syncCurrentRecipeDisplayName = (mainLabelId, labelId, value, displayValue) => {
  if (`${mainLabelId}` !== `${labelId}`) {
    return;
  }

  const previewTitle = document.querySelector(".printlike-recipe-title");
  if (previewTitle) {
    previewTitle.textContent = displayValue;
  }

  const badge = document.querySelector("#recipe-display-name-badge");
  const badgeText = badge?.querySelector(".recipe-display-name-text");
  if (badge && badgeText) {
    badgeText.textContent = value;
    badge.style.display = value ? "" : "none";
  }

  const modalInput = document.querySelector("#recipe-display-name-input");
  if (modalInput) {
    modalInput.value = value;
  }
};

export const initializeAggregateControls = () => {
  const mainLabelId = window.recipe_label?.id;

  document.querySelectorAll("[data-aggregate-recipe-name-input-fr]").forEach((el) => {
    el.addEventListener("change", async (event) => {
      const labelId = event.target.dataset["recipeLabel"];
      const value = normalizeBlankValue(event.target.value);
      const success = await saveLabel({ [event.target.name]: value }, labelId);

      if (success) {
        const displayValue = value || event.target.placeholder;
        event.target.value = value;
        document.querySelectorAll(`[data-recipe-name-display-fr="${labelId}"]`).forEach((el) => {
          el.textContent = displayValue;
        });
        Flash.success("Display name updated");
      } else {
        Flash.error("Could not save");
      }
    });
  });

  document.querySelectorAll("[data-aggregate-recipe-name-input-en]").forEach((el) => {
    el.addEventListener("change", async (event) => {
      const labelId = event.target.dataset["recipeLabel"];
      const value = normalizeBlankValue(event.target.value);
      const success = await saveLabel({ [event.target.name]: value }, labelId);

      if (success) {
        event.target.value = value;
        const displayValue = value || event.target.placeholder;
        document.querySelectorAll(`[data-recipe-name-display-en="${labelId}"]`).forEach((el) => {
          el.textContent = displayValue;
        });
        syncCurrentRecipeDisplayName(mainLabelId, labelId, value, displayValue);
        Flash.success("Display name updated");
      } else {
        Flash.error("Could not save");
      }
    });
  });
};
